/*
 * eventLineupFilter - location + format filtering for the event lineup
 * (CinemaEvent/Detail.Custom.cshtml).
 *
 * Progressive enhancement over the server-rendered poster grid: it reads the
 * per-poster data-* attributes that Razor emits (built from the event SJO's real
 * showtimes), builds a Location and a Format dropdown, grays out impossible combos
 * as the user narrows (same behaviour as the homepage filter, minus the date), and
 * rewrites each poster's link (?cinema=&format=) so clicking through lands on the
 * film detail page pre-filtered.  It also mirrors the selection into the page URL.
 *
 * Why data-driven: after the shared IMAX / C Premium format grouping was removed
 * (2026-08), a poster must carry its film's ACTUAL formats so the detail page shows
 * them.  Default (nothing selected) => each poster links with all of its own formats;
 * pick a format and every poster narrows to that one.
 *
 * Plain jQuery so it needs no Angular bootstrap on the event page.  Lives under
 * Mvc/Scripts/Celebration and is bundled into CelebrationScripts.min.js.
 */
(function () {
    // VistaID -> display name.  Same hard-coded list used elsewhere (jquery-init.js);
    // cinemas rarely change and the event SJO does not carry cinema names.
    var CINEMA_NAMES = {
        "002": "GR North", "003": "Crossroads", "004": "GR South", "005": "Rivertown",
        "006": "Lansing", "007": "Benton Harbor", "008": "Mt Pleasant", "009": "Cinema Carousel",
        "011": "Getty", "012": "Meridian Mall", "013": "Studio Park"
    };

    function initEventLineup($) {
        var $root = $(".event-lineup");
        if (!$root.length) return;

        var $links = $root.find("a.event-poster-link");
        if (!$links.length) return;

        var $controls = $(".event-lineup-controls");
        var $loc = $controls.find(".event-filter-location");
        var $fmt = $controls.find(".event-filter-format");
        if (!$loc.length || !$fmt.length) return;

        var allPairs = [];   // [{c, f}] every cinema+format combo across the lineup
        var cinemaSet = [];  // distinct VistaIDs
        var formatSet = [];  // distinct friendly format strings
        var posters = [];

        function addUnique(arr, v) { if (arr.indexOf(v) < 0) arr.push(v); }

        $links.each(function () {
            var $a = $(this);
            var pairsAttr = ($a.attr("data-pairs") || "").toString();
            var pObjs = [];
            pairsAttr.split(",").forEach(function (p) {
                var idx = p.indexOf("|");
                if (idx < 0) return;
                var c = p.substring(0, idx).trim();
                var f = p.substring(idx + 1).trim();
                if (!c || !f) return;
                pObjs.push({ c: c, f: f });
                if (!allPairs.some(function (x) { return x.c === c && x.f === f; })) allPairs.push({ c: c, f: f });
                addUnique(cinemaSet, c);
                addUnique(formatSet, f);
            });
            posters.push({
                $a: $a,
                $cell: $a.closest(".col-lg-6"),
                pairs: pObjs,
                base: ($a.attr("data-detailurl") || "").toString(),
                dateParam: ($a.attr("data-dateparam") || "").toString(),
                formats: ($a.attr("data-formats") || "").toString() // comma list of this film's own formats
            });
        });

        // Nothing to filter on (single cinema AND single format) -> leave the static grid alone.
        if (cinemaSet.length < 2 && formatSet.length < 2) return;

        cinemaSet.sort(function (a, b) { return (CINEMA_NAMES[a] || a).localeCompare(CINEMA_NAMES[b] || b); });
        formatSet.sort(function (a, b) { return a.localeCompare(b); });

        cinemaSet.forEach(function (c) { $loc.append($("<option>").val(c).text(CINEMA_NAMES[c] || c)); });
        formatSet.forEach(function (f) { $fmt.append($("<option>").val(f).text(f)); });

        var selCinema = "";
        var selFormat = "";

        // A cinema option is selectable if some pair has it AND honours the current format selection.
        function cinemaAvailable(c) {
            return allPairs.some(function (p) { return p.c === c && (!selFormat || p.f === selFormat); });
        }
        // A format option is selectable if some pair has it AND honours the current location selection.
        function formatAvailable(f) {
            return allPairs.some(function (p) { return p.f === f && (!selCinema || p.c === selCinema); });
        }

        function updateOptionStates() {
            $loc.find("option").each(function () {
                var v = $(this).val();
                if (!v) return; // "All Locations"
                var ok = cinemaAvailable(v);
                $(this).prop("disabled", !ok);
                var base = CINEMA_NAMES[v] || v;
                $(this).text(ok ? base : base + " (none)");
            });
            $fmt.find("option").each(function () {
                var v = $(this).val();
                if (!v) return; // "All Formats"
                var ok = formatAvailable(v);
                $(this).prop("disabled", !ok);
                $(this).text(ok ? v : v + " (none)");
            });
        }

        function posterVisible(p) {
            if (!selCinema && !selFormat) return true;
            return p.pairs.some(function (pr) {
                if (selCinema && pr.c !== selCinema) return false;
                if (selFormat && pr.f !== selFormat) return false;
                return true;
            });
        }

        function buildHref(p) {
            var url = p.base + p.dateParam;             // dateParam already begins with "?date=..."
            var sep = p.dateParam ? "&" : "?";
            if (selCinema) { url += sep + "cinema=" + encodeURIComponent(selCinema); sep = "&"; }
            // selected format narrows the link; otherwise carry the film's own formats (comma list)
            var fmtVal = selFormat ? selFormat : p.formats;
            if (fmtVal) { url += sep + "format=" + encodeURIComponent(fmtVal); sep = "&"; }
            return url;
        }

        function syncUrl() {
            if (!window.history || !window.history.replaceState) return;
            var qs = [];
            if (selCinema) qs.push("cinema=" + encodeURIComponent(selCinema));
            if (selFormat) qs.push("format=" + encodeURIComponent(selFormat));
            var newUrl = window.location.pathname + (qs.length ? "?" + qs.join("&") : "") + window.location.hash;
            window.history.replaceState(null, "", newUrl);
        }

        function apply() {
            var visible = 0;
            posters.forEach(function (p) {
                var vis = posterVisible(p);
                p.$cell.toggle(vis);
                if (vis) { visible++; p.$a.attr("href", buildHref(p)); }
            });
            updateOptionStates();
            $root.find(".event-no-results").toggle(visible === 0);
            syncUrl();
        }

        function getParam(name) {
            var m = new RegExp("[?&]" + name + "=([^&]*)").exec(window.location.search);
            return m ? decodeURIComponent(m[1].replace(/\+/g, " ")) : "";
        }

        // Preselect from the URL (a shared/deep link to this event with ?cinema= / ?format=).
        var urlCinema = getParam("cinema");
        var urlFormat = getParam("format");
        if (urlCinema && cinemaSet.indexOf(urlCinema) >= 0) selCinema = urlCinema;
        if (urlFormat && formatSet.indexOf(urlFormat) >= 0) selFormat = urlFormat; // single known format only
        $loc.val(selCinema);
        $fmt.val(selFormat);

        $loc.on("change", function () { selCinema = $(this).val() || ""; apply(); });
        $fmt.on("change", function () { selFormat = $(this).val() || ""; apply(); });

        $root.on("click", ".event-clear-filters", function (e) {
            e.preventDefault();
            selCinema = ""; selFormat = "";
            $loc.val(""); $fmt.val("");
            apply();
        });

        $controls.show();
        apply();
    }

    if (window.jQuery) {
        window.jQuery(function () { initEventLineup(window.jQuery); });
    }
})();
